import { useEffect } from "react";
import { useOrganizations } from "@/hooks/useOrganizations";
import OrganizationList from "@/components/OrganizationList";
import { toast } from "sonner";
import { useLanguage } from "@/contexts/LanguageContext";

const ITEMS_PER_PAGE = 12;

const Organizations = () => {
  const { t } = useLanguage();

  const { organizations, meta, isLoading, isError, pagination, goToPage } =
    useOrganizations(ITEMS_PER_PAGE);

  useEffect(() => {
    document.title = "Silvaconsult Registry | " + t("common.organizations");
  }, [t]);

  useEffect(() => {
    if (isError) {
      toast.error(t("common.error"), {
        description: t("common.noData"),
      });
    }
  }, [isError, t]);

  return (
    <div className="min-h-screen bg-[#f0f4f8]">
      {/* Main content */}
      <div className="container max-w-6xl mx-auto px-4 py-8">
        <div className="mb-6">
          <h1 className="text-2xl font-medium">{t("organizations.title")}</h1>
          <p className="text-gray-500 mt-1">{t("organizations.description")}</p>
        </div>

        <div className="bg-white rounded-xl p-6 shadow-sm mb-6 py-[6px]">
          <div className="flex justify-between items-center mb-6">
            <div></div>
          </div>

          <OrganizationList
            organizations={organizations}
            isLoading={isLoading}
            meta={meta}
            onPageChange={goToPage}
            currentPage={pagination.page}
          />
        </div>
      </div>

      {/* Footer */}
      <footer className="py-8 text-center text-gray-500 text-sm">
        <div className="container mx-auto px-4">
          <p>© {new Date().getFullYear()} Transaction Registry</p>
        </div>
      </footer>
    </div>
  );
};

export default Organizations;
